export const HEAR_ABOUT_US_SOURCES = [
  { value: "google", label: "Google", color: "#e74c3c" },
  { value: "facebook", label: "Facebook", color: "#00897b" },
  { value: "instagram", label: "Instagram", color: "#26c6da" },
  { value: "events", label: "Events", color: "#7cb342" },
  { value: "flyers", label: "Flyers", color: "#f6c445" },
  { value: "others", label: "Others", color: "#6d4c41" },
] as const;

export type HearAboutUsSource = (typeof HEAR_ABOUT_US_SOURCES)[number]["value"];

export const HEAR_ABOUT_US_VALUES: HearAboutUsSource[] = HEAR_ABOUT_US_SOURCES.map(
  (source) => source.value
);

export const HEAR_ABOUT_US_COLOR_BY_SOURCE: Record<HearAboutUsSource, string> =
  HEAR_ABOUT_US_SOURCES.reduce(
    (acc, source) => {
      acc[source.value] = source.color;
      return acc;
    },
    {} as Record<HearAboutUsSource, string>
  );

export const HEAR_ABOUT_US_OTHER_MAX_LENGTH = 200;
